import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WysiwygIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wysiwyg"}/>
}
